import { OrderMeal } from './order';

export interface SustainabilityMetrics {
  [key: string]: number | undefined;
  numOfOrders: number;
  climateChange: number;
  animalWelfare: number;
  soilHealth: number;
  waterReduction: number;
  organicLand: number;
}

export interface SustainabilityHistoryRequest {
  startDate: Date;
  endDate: Date;
}

export interface OrderAndHistorySustainabilityMetrics {
  order: SustainabilityMetrics | null;
  history: SustainabilityMetrics | null;
}

export interface OrderAndHistoryMetricsRequest {
  orderId: string;
  isGuest: boolean;
  country: string;
  meals: OrderMeal[];
  orderSubmitDateTimeUtc: string;
  startDate?: string;
  endDate?: string;
}

export interface SustainabilityCopy {
  metricType: string;
  metricHeadline: string;
  drawerCopy: string;
  unit: string;
}

// Used to order the metric cards
export const sustainabilityCopyList: SustainabilityCopy[] = [
  {
    metricType: 'climateChange',
    drawerCopy: 'Carbon reduction practices on-farm include rotational grazing, organic growing, etc.',
    metricHeadline: 'Less Carbon in the Atmosphere',
    unit: 'GRAMS',
  },
  {
    metricType: 'organicLand',
    drawerCopy: 'Chipotle continues to serve more organic food than any other national restaurant group.',
    metricHeadline: 'Supported Organic Land',
    unit: 'SQ. FEET',
  },
  {
    metricType: 'animalWelfare',
    drawerCopy: 'Avoiding antibiotics in meat and dairy is a part of Chipotle’s award-winning animal welfare standards.',
    metricHeadline: 'Antibiotics Avoided',
    unit: 'MILLIGRAMS',
  },
  {
    metricType: 'waterReduction',
    drawerCopy: 'We are committed to sourcing from farms with sustainable agriculture practices that use less water.',
    metricHeadline: 'Gallons of Water Saved',
    unit: 'GALLONS',
  },
  {
    metricType: 'soilHealth',
    drawerCopy: 'We strive to source ingredients from farms with sustainable agriculture practices that improve the soil.',
    metricHeadline: 'Improved Soil Health ',
    unit: 'SQ. FEET',
  },
];
